import React              from 'react';
import ActivityIndicator  from '../../shared/activity-indicator/activity-indicator.jsx';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import LocaleString       from '../../shared/locale-string';
import Back               from '../../shared/back';

import {
    Alert,
    CloseCircleIcon
} from '../../shared';

import './rules.scss';

class Rules extends React.Component {
    constructor( props ) {
        super( props );

        this.state = {
            ruleIndex: 0
        };
    }

    UNSAFE_componentWillMount() {//eslint-disable-line
        this.updateRulesText( 0 );

        window.addEventListener( 'orientationchange', this.scaleTables );
        document.addEventListener( 'keydown', this.handleTabNav );
    }

    componentWillUnmount() {
        this.props.errors.forEach( error => this.props.dismissError( error ) );

        window.removeEventListener( 'orientationchange', this.scaleTables );
        document.removeEventListener( 'keydown', this.handleTabNav );
    }

    componentDidUpdate() {
        this.scaleTables();
        this.removeFirstTextPadding();
    }

    // this function is to scale any tables in the rules content so they don't look like crap in mobile.
    scaleTables = () => {
        const tables = document.getElementsByTagName( 'table' );

        for ( let i = 0; i < tables.length; i++ ) {
            tables[ i ].style.transform = '';

            // - 32 is to account for a padding of 1rem (16px) on each side.
            const scale = Math.min( 1, ( this.refs.content.clientWidth - 32 ) / ( tables[ i ].offsetLeft + tables[ i ].clientWidth ) );
            tables[ i ].style.transformOrigin = 'left center 0px';
            tables[ i ].style.transform = 'scale(' + scale.toString() + ')';

            const margin = ( tables[ i ].clientHeight - tables[ i ].clientHeight * scale );
            tables [ i ].style.marginTop = ( margin / -2 ).toString() + 'px';
            tables [ i ].style.marginBottom = ( margin / -2 ).toString() + 'px';
        }
    };

    handleTabNav = event => {
        const keyCode = event.keyCode;
        const ltr = document.dir === 'ltr';
        const activeEl = document.activeElement;
        let elToActivate;

        if ( activeEl.getAttribute( 'role' ) !== 'tab' || keyCode < 37 || keyCode > 40 ) {
            return false;
        }

        if ( ltr ) {
            switch ( keyCode ) {
                case 37:
                case 38:
                    elToActivate = this.getPrevTab( activeEl );
                    break;
                case 39:
                case 40:
                    elToActivate = this.getNextTab( activeEl );
                    break;
            }
        } else {
            switch ( keyCode ) {
                case 38:
                case 39:
                    elToActivate = this.getPrevTab( activeEl );
                    break;
                case 37:
                case 40:
                    elToActivate = this.getNextTab( activeEl );
                    break;
            }
        }

        if ( elToActivate ) {
            elToActivate.click();
            elToActivate.focus();
        }
    };

    // return previous tab or false if we are already on the first tab
    getPrevTab = tab => {
        const prevSibling = tab.parentNode.previousSibling;
        return prevSibling ? prevSibling.firstChild : false;
    };

    // return next tab or false if we are on the last tab
    getNextTab = tab => {
        const nextSibling = tab.parentNode.nextSibling;
        return nextSibling ? nextSibling.firstChild : false;
    };

    removeFirstTextPadding = () => {
        if ( this.props.participantRules.length > 1 ) {
            const findTextElement = ( element ) => {
                if ( element ) {
                    if ( element.nodeName === 'P' || element.nodeName.indexOf( 'H' ) === 0 ) {
                        return element;
                    } else if ( element.childNodes.length > 0 ) {
                        return findTextElement( element.childNodes[ 0 ] );
                    }
                } else {
                    return null;
                }
            };

            const textElement = findTextElement( this.refs.content );

            if ( textElement ) {
                textElement.style.marginTop = '0';
                textElement.style.lineHeight = '1';
            }
        }
    };

    handleProgramClick = ( event, index ) => {
        event.preventDefault();

        if ( this.state.ruleIndex !== index ) {
            this.updateRulesText( index );
        }
    };

    updateRulesText = ( index ) => {
        const {
            requestRulesText,
            participantRules
        } = this.props;

        const cmmoKey = participantRules.length === 0 ? '' :
            participantRules[ index ].ruleText;

        if ( cmmoKey ) {
            requestRulesText( cmmoKey );
        }

        if ( this.state.ruleIndex !== index ) {
             this.setState( { ruleIndex: index } );
        }
    };

    render() {
        const {
            busy,
            errors,
            dismissError,
            rulesText,
            participantRules
        } = this.props;

        const cmmoKey = participantRules.length === 0 ? '' :
            participantRules[ this.state.ruleIndex ].ruleText;

        const ruleText = busy ? '' : rulesText[ cmmoKey ];

        return (
            <div className="rules">

                <div className="content-container">
                    <div className="title" >
                        <Back className="back">
                            <CloseCircleIcon />
                        </Back>
                        <h1><LocaleString code="rules.page.header" /></h1>
                    </div>

                    { busy && <ActivityIndicator visible={ busy } /> }

                    <div className="section-container">
                        <div className="left-section">
                            { participantRules.length > 1 &&
                                <ul className="program-list" role="tablist">
                                    { participantRules.map( ( participantRule, index ) => {
                                        const isSelected = index === this.state.ruleIndex;
                                        return <li key={ index } role="presentation">
                                            <a  href="#"
                                                id={ `rulesTab${index}` }
                                                role="tab"
                                                aria-selected={ isSelected }
                                                className={ isSelected ? 'active' : null }
                                                onClick={ ( e ) => this.handleProgramClick( e, index ) }>
                                                { participantRule.programName }
                                            </a>
                                        </li>;
                                    } ) }
                                </ul>
                            }
                        </div>

                        <div className="right-section" ref="content" >
                            <CSSTransitionGroup className="rule-container"
                                transitionName="rule-animate"
                                transitionEnterTimeout={ 600 }
                                transitionLeaveTimeout={ 600 }>
                                <div key={ this.state.ruleIndex } dangerouslySetInnerHTML={ { __html: ruleText } }  />
                            </CSSTransitionGroup>

                            {
                                errors.length !== 0 && errors.map( ( error, index ) =>
                                    <Alert type={ 'error' } onDismiss={ () => dismissError( error ) } key={ index }>
                                        <p>{ error.responseMessage || error.message }</p>
                                    </Alert>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default Rules;
